<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>纸搬客南华里社区环保专题采访</h2>
                <p class="p-1"><span class="span-1">北京纸搬客科技有限公司</span>2020年5月1日</p>
                <div class="details">
                    <img src="../../assets/img/newTwo/1.png" alt="" class="img-2">
                    <p class="p-1">为响应国家垃圾分类的环保号召、助力垃圾分类，纸搬客通过与社区物业、居委会单位的合作，将自主研发的纸搬客智能废纸回收机入驻社区，协助物业、居委会建立社区内的垃圾分类回收体系，为用户挖掘“垃圾”价值，这一方式受到了物业、居委会以及用户的一致好评。</p>
                    <img src="../../assets/img/newTwo/2.png" alt="" class="img-2">
                    <p class="p-1 p-spe">在“世界地球日”当天，纸搬客入驻社区-南华里社区受邀接受来自“首都财经频道”的记者采访</p>
                    <p class="p-1">纸搬客创始人兼CEO李嘉轩李总，以及南华里社区鲁能物业单位负责人杨玉全杨经理，协助“首都财经频道”记者，完成了本次采访</p>
                    <img src="../../assets/img/newTwo/3.png" alt="" class="img-2">
                    <p class="p-3">（左：南华里物业经理杨玉全      右：纸搬客创始人兼CEO李嘉轩”）</p>
                    <p class="p-1">同时记者也邀请了当天正在使用纸搬客智能废纸回收机的“郭大爷”以及“陈大妈”，两位纸搬客忠实粉丝为大家分享“碎纸心得”。</p>
                    <img src="../../assets/img/newTwo/4.png" alt="" class="img-2">
                    <p class="p-3 p-bottom">（左：纸搬客用户“陈大妈”        右：纸搬客用户“郭大爷”）</p>
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 5.4rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 5.4rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.048rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.1rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.04rem;
        font-family:PingFang SC;
        font-weight:500;
        color: #444;
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        margin-bottom: 0.08rem;
    }
    .img-2{
        width: 100%;
        height: 100%;
        margin-top: 0.07rem;
    }
    .p-3{
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 0.04rem;
    }
    .p-bottom{
        margin-bottom: 0.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newTwo.vue